import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/view/Login';
import Home from '@/view/Home';
import Map from '@/view/map/mapshow.vue';
import YsyMap from '@/view/map/YsyMap.vue';

Vue.use (Router);

export default new Router ({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/map',
      name: 'Map',
      component: Map,
    },
    {
      path: '/ysy-map',
      name: 'YsyMap',
      component: YsyMap,
    },

    {
      path: '/Home',
      name: 'Home',
      component: Home,
      redirect: '/Home/Console',
      meta: {requiresAuth: true},
      children: [
        {
          path: '/Home/Console',
          name: '控制台',
          component: resolve => require (['../view/Console.vue'], resolve),
          meta: {requiresAuth: 'CONSOLE:MONITOR'},
        },
        {
          path: '/auditingManage',
          name: '审计管理',
          meta: {requiresAuth: ' LOGIN_AUDIT:LIST'},
          component: resolve =>
            require (['../view/auditingManage'], resolve),
        },
        {
          path: '/Home/NoPermission',
          name: '无权限',
          component: resolve => require (['../view/NoPermission.vue'], resolve),
          meta: {requiresAuth: true},
        },
        {
          path: '/Home/SceneMonit',
          name: '现场监控',
          component: resolve =>
            require (['../view/SceneMonitor/SceneMonit.vue'], resolve),
          redirect: '/SceneMonit/SiteLIst',
          children: [
            {
              path: '/SceneMonit/SiteLIst',
              name: '站点列表',
              meta: {requiresAuth: 'MO:LIST'},
              component: resolve =>
                require (['../view/SceneMonitor/SiteLIst.vue'], resolve),
            },
            {
              path: '/SceneMonit/SiteParti',
              name: '站点详情',
              meta: {requiresAuth: 'MO:LIST'},
              component: resolve =>
                require (['../view/SiteParti/SiteParti.vue'], resolve),
              children: [
                {
                  path: '/SceneMonit/SiteParti/Scene',
                  name: '现场',
                  meta: {requiresAuth: 'MO:LIST'},
                  component: resolve =>
                    require (['../view/SiteParti/Scene.vue'], resolve),
                },
                {
                  path: '/SceneMonit/SiteParti/Chart',
                  name: '图表',
                  meta: {requiresAuth: 'MO:LIST'},
                  component: resolve =>
                    require (['../view/SiteParti/Chart.vue'], resolve),
                },
                {
                  path: '/SceneMonit/SiteParti/List',
                  name: '列表',
                  meta: {requiresAuth: 'MO:LIST'},
                  component: resolve =>
                    require (['../view/SiteParti/List.vue'], resolve),
                },
                {
                  path: '/SceneMonit/SiteParti/Circuit',
                  name: '线路',
                  meta: {requiresAuth: 'MO:LIST'},
                  component: resolve =>
                    require (['../view/SiteParti/Circuit.vue'], resolve),
                },
              ],
            },
            {
              path: '/SceneMonit/Alarm',
              name: '报警信息',
              meta: {requiresAuth: 'MO_ALARM:LIST'},
              component: resolve =>
                require (['../view/SceneMonitor/Alarm.vue'], resolve),
            },
            {
              path: '/SceneMonit/Inform',
              name: '通知信息',
              meta: {requiresAuth: 'MO:LIST'},
              component: resolve =>
                require (['../view/SceneMonitor/Inform.vue'], resolve),
            },
            {
              path: '/SceneMonit/SiteInfoComp',
              name: '站点信息对比',
              meta: {requiresAuth: 'MO:LIST'},
              component: resolve =>
                require (['../view/SceneMonitor/SiteInfoComp.vue'], resolve),
            },
            {
              path: '/SceneMonit/SiteMap',
              name: '站点地图',
              meta: {requiresAuth: 'MO:LIST'},
              component: resolve =>
                require (['../view/SceneMonitor/SiteMap.vue'], resolve),
            },
            {
              path: '/SceneMonit/SiteBasInfo',
              name: '站点基础信息',
              meta: {requiresAuth: 'MO:LIST'},
              component: resolve =>
                require (['../view/SceneMonitor/SiteBasInfo.vue'], resolve),
            },
          ],
        },
        {
          path: '/Hadoop/LiquidLevel',
          name: '用量液位分析(管理方)',
          meta: {requiresAuth: 'BD_LLS:LIST'},
          component: resolve =>
            require (['../view/Hadoop/LiquidLevel.vue'], resolve),
        },
        {
          path: '/Hadoop/LiquidLevelTwo',
          name: '用量液位分析(经营方)',
          meta: {requiresAuth: 'BD_USER_LLS:LIST'},
          component: resolve =>
            require (['../view/Hadoop/LiquidLevelTwo.vue'], resolve),
        },
        {
          path: '/Hadoop/LiquidStatistics',
          name: '用量液位统计详情',
          //  			meta:{requiresAuth:'BD_USER_LLS:LIST',},
          component: resolve =>
            require (['../view/Hadoop/LiquidStatistics.vue'], resolve),
        },
        {
          path: '/Hadoop/levelStatis',
          name: '液位统计',
          meta: {requiresAuth: 'BD_LLS_RESULT:LIST'},
          component: resolve => require (['../view/Hadoop/levelStatis.vue'], resolve),
        },
        {
          path: '/Hadoop/AbnormalStati',
          name: '异常统计分析',
          //  			meta:{requiresAuth:'BD_USER_LLS:LIST',},
          component: resolve =>
            require (['../view/Hadoop/AbnormalStati.vue'], resolve),
        },
        {
          path: '/Hadoop/OnlineRate',
          name: '在线率统计',
          meta: {requiresAuth: 'BD_ONLINE:LIST'},
          component: resolve =>
            require (['../view/Hadoop/OnlineRate.vue'], resolve),
        },
        {
          path: '/Hadoop/ServeRate',
          name: '服务费统计',
          meta: {requiresAuth: 'BD_MONEY:LIST'},
          component: resolve =>
            require (['../view/Hadoop/ServeRate.vue'], resolve),
        },
        {
          path: '/Hadoop/AccountNum',
          name: '账号统计',
          meta: {requiresAuth: 'BD_ACCOUNT:LIST'},
          component: resolve =>
            require (['../view/Hadoop/AccountNum.vue'], resolve),
        },
        {
          path: '/Hadoop/DataComp',
          name: '数据对比',
          meta: {requiresAuth: 'BD_LLS:LIST'},
          component: resolve =>
            require (['../view/Hadoop/DataComp.vue'], resolve),
        },
        {
          path: '/Hadoop/FluidSite',
          name: '待补液站点',
          meta: {requiresAuth: 'BD_LLS:LIST'},
          component: resolve =>
            require (['../view/Hadoop/FluidSite.vue'], resolve),
        },
        {
          path: '/Hadoop/GasConsumption',
          name: '用气量报表',
          meta: {requiresAuth: 'BD_USE_REPORT:LIST'},
          component: resolve =>
            require (['../view/Hadoop/GasConsumption.vue'], resolve),
        },
        {
          path: '/Home/Toolkit',
          name: '工具箱',
          component: resolve =>
            require (['../view/Toolkit/Toolkit.vue'], resolve),
          children: [
            {
              path: '/Toolkit/Calculator',
              meta: {requiresAuth: 'TB:CAL'},
              name: '计算器',
              component: resolve =>
                require (['../view/Toolkit/Calculator.vue'], resolve),
            },
            {
              path: '/Toolkit/DataDebug',
              meta: {requiresAuth: 'TB:DATE-DEBUG'},
              name: '数据调试',
              component: resolve =>
                require (['../view/Toolkit/DataDebug.vue'], resolve),
            },
            {
              path: '/Toolkit/LongConfig',
              meta: {requiresAuth: 'TB:CONFIG'},
              name: '远程配置',
              component: resolve =>
                require (['../view/Toolkit/LongConfig.vue'], resolve),
              children: [
                {
                  path: '/LongConfig/BaseDeploy',
                  meta: {requiresAuth: 'TB:CONFIG'},
                  name: '7c-基础配置',
                  component: resolve =>
                    require (['../view/RtuSevenC/BaseDeploy.vue'], resolve),
                },
                {
                  path: '/LongConfig/UpGrade',
                  meta: {requiresAuth: 'TB:CONFIG'},
                  name: '7c-远程升级',
                  component: resolve =>
                    require (['../view/RtuSevenC/UpGrade.vue'], resolve),
                },
                {
                  path: '/LongConfig/CollectDeploy',
                  meta: {requiresAuth: 'TB:CONFIG'},
                  name: '7c-采集项配置',
                  component: resolve =>
                    require (['../view/RtuSevenC/CollectDeploy.vue'], resolve),
                },
                {
                  path: '/LongConfig/LongUp',
                  meta: {requiresAuth: 'TB:CONFIG'},
                  name: '7c-远程下发',
                  component: resolve =>
                    require (['../view/RtuSevenC/LongUp.vue'], resolve),
                },
                {
                  path: '/LongConfig/OnlineDeploy',
                  meta: {requiresAuth: 'TB:CONFIG'},
                  name: '7c-网络配置',
                  component: resolve =>
                    require (['../view/RtuSevenC/OnlineDeploy.vue'], resolve),
                },
                {
                  path: '/LongConfig/Cylinder',
                  meta: {requiresAuth: 'TB:CONFIG'},
                  name: '7c-钢瓶参数',
                  component: resolve =>
                    require (['../view/RtuSevenC/Cylinder.vue'], resolve),
                },
              ],
            },
            {
              path: '/Toolkit/BugWindow',
              meta: {requiresAuth: 'TB:CONFIG'},
              name: '调试窗口',
              component: resolve =>
                require (['../view/Toolkit/BugWindow.vue'], resolve),
            },
            {
              path: '/Toolkit/UnitConve',
              meta: {requiresAuth: 'TB:CONFIG'},
              name: '单位换算',
              component: resolve =>
                require (['../view/Toolkit/UnitConve.vue'], resolve),
            },
          ],
        },
      ],
    },

    {
      path: '/BigMap',
      name: '大屏地图',
      meta: {requiresAuth: 'BIGMAP:LIST'},
      component: resolve => require (['../view/BigMap/BigMap.vue'], resolve),
    },
    {
      path: '/SceneMonit/BigTable',
      name: '大屏表格',
      meta: {requiresAuth: 'BIGMAP:LIST'},
      component: resolve =>
        require (['../view/SceneMonitor/BigTable.vue'], resolve),
    },
    {
      path: '/SceneMonit/SlTable',
      name: '胜利油田大屏',
      meta: {requiresAuth: 'BIGMAP:LIST'},
      component: resolve =>
        require (['../view/SceneMonitor/SlTable.vue'], resolve),
    },
    {
      path: '/SceneMonit/UseGasList',
      name: '用气点列表监控',
      meta: {requiresAuth: 'MO:LIST'},
      component: resolve =>
        require (['../view/SceneMonitor/UseGasList.vue'], resolve),
    },
    {
      path: '/SceneMonit/JiaShanMonito',
      name: '站点列表监控',
      meta: {requiresAuth: 'MO:LIST'},
      component: resolve =>
        require (['../view/SceneMonitor/JiaShanMonito.vue'], resolve),
    },
    {
      path: '/SceneMonit/Car',
      name: '车辆监控',
      meta: {requiresAuth: 'MO:LIST'},
      component: resolve => require (['../view/SceneMonitor/Car.vue'], resolve),
    },
    {
      path: '/SceneMonit/CarTrack',
      name: '车辆轨迹',
      meta: {requiresAuth: 'MO:LIST'},
      component: resolve =>
        require (['../view/SceneMonitor/CarTrack.vue'], resolve),
    },
    {
      path: '/Hub',
      name: 'hub',
      component: resolve => require (['../view/Hub.vue'], resolve),
    },
  ],
});
